// The Call button in the lead page's communication hub (next to Phone). Opens
// the one dialer pre-filled with the lead (CU-869fmbgfj). Renders nothing,
// label included, unless this user can call from the CRM.
import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import Iconify from '../Iconify';
import { useOutbound } from './OutboundCallProvider';
import { useDialer } from './dialerContext';
import { isDiallable } from './outboundModel';

export default function LeadPageCallButton({ to, leadId, buttonSx }) {
    const outbound = useOutbound();
    const dialer = useDialer();
    const widget = Boolean(dialer?.canOpen);
    // On a lead's page the button is always there; with no usable number of its own the dialer's
    // server pre-fill works the number out from the lead (CU-869fmc59c).
    const hasLead = leadId !== undefined && leadId !== null && leadId !== '';
    if (!(widget || outbound?.canCall)) return null;
    if (!isDiallable(to) && !(widget && hasLead)) return null;
    const title = !widget && outbound?.desk ? `Call from ${outbound.desk.name || 'your desk'}` : 'Call';
    const start = () => {
        if (widget) dialer.openDialer({ to: isDiallable(to) ? to : '', leadId: leadId ?? null });
        else outbound.startCall({ to, leadId: leadId ?? null });
    };
    return (
        <Box sx={{ textAlign: 'center' }}>
            <Tooltip title={title}>
                <span>
                    <IconButton
                        onClick={start}
                        disabled={Boolean(widget ? dialer.isCalling : outbound?.busy)}
                        aria-label={isDiallable(to) ? `Call ${to}` : 'Call'}
                        data-testid="lead-page-call-button"
                        sx={buttonSx}
                    >
                        <Iconify icon="solar:phone-calling-rounded-bold" width={22} height={22} sx={{ color: 'primary.main' }} />
                    </IconButton>
                </span>
            </Tooltip>
            <Typography sx={{ fontSize: '10px', color: 'grey.500', mt: 0.25 }}>Call</Typography>
        </Box>
    );
}

LeadPageCallButton.propTypes = {
    to: PropTypes.string,
    leadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    buttonSx: PropTypes.object,
};
